export default {
  'dept.title': 'Επωνυμία Εταιρίας',
  'dept.btn.add': 'Προσθήκη Εταιρίας',
  'dept.btn.addSubsidiary': 'Προσθήκη τμήματος',
  'dept.btn.edit': 'Επεξεργασία Εταρίας',
  'dept.btn.del': 'Διαγραφή Εταιρίας',
  'dept.input.dept.placeholder': 'Παρακαλώ εισάγετε Επωνυμία Εταιρίας',
};
